module.exports = __webpack_public_path__ + "static/media/ag.f3458587.svg";